import { render, staticRenderFns } from "./avatar_upi_data.vue?vue&type=template&id=5860da08"
import script from "./avatar_upi_data.vue?vue&type=script&lang=js"
export * from "./avatar_upi_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports